<template>
  <div class="container">
    <content-header :data="[{text:'部门列表', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
      </div>
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 800px">
          <el-table-column
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            prop="name"
            label="部门">
          </el-table-column>
          <el-table-column
            prop="modifier_name"
            label="操作人"
            width="100">
          </el-table-column>
          <el-table-column
            prop="modified"
            label="操作时间">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small">修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="new-wrap">
        <el-dialog :title="curObj.row.id ? '修改部门' : '添加部门'" width="30%" :visible.sync="isNewShow">
          <el-form :model="newObj">
            <el-form-item label="部门名称" :label-width="formLabelWidth">
              <el-input v-model="newObj.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isNewShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>

          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import DepartmentModel from 'models/department'
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        tableData: [],
        newObj: {
          name: ''
        },
        curObj: {
          row: {}
        },
        isEdit: false,
        isNewShow: false,
        formLabelWidth: '80px'
      }
    },
    created () {
      DepartmentModel.find().then(res => {
        console.log(res)
        this.tableData = res.department_list
      })
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    methods: {
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            DepartmentModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        if (!this.newObj.name) return
        if (this.isEdit) return this.editHandle()
        this.newHandle()
      },
      initNewHandle () {
        this.curObj = { row: {} }
        this.newObj = {
          name: ''
        }
        this.isEdit = false
        this.isNewShow = true
      },
      newHandle () {
        DepartmentModel.create({
          name: this.newObj.name
        }).then(res => {
          // console.log(res)
          DepartmentModel.find().then(res => {
            this.tableData = res.department_list
          })
          this.isNewShow = false
          this.newObj.name = ''
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = item
        this.newObj = {
          name: item.row.name
        }
        this.isEdit = true
        this.isNewShow = true
      },
      editHandle () {
        DepartmentModel.update({
          id: this.curObj.row.id,
          name: this.newObj.name
        }).then(res => {
          DepartmentModel.find().then(res => {
            this.tableData = res.department_list
          })
          this.isNewShow = false
          this.newObj.name = ''
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
    .new-wrap
      .el-input
        width: 85%
</style>



// WEBPACK FOOTER //
// src/views/Department.vue